import { apiRequest } from '@common/api/utils';
import { getGoogleClientId } from '@tracking/components/utils';
import {
  GTM_FALLBACK_API,
} from '@tracking/components/constants';

const sendEventsToServer = () => {
  if (window.google_tag_manager) {
    return;
  }
  const clientId = getGoogleClientId();
  const events = window.dataLayer.splice(0, window.dataLayer.length);
  if (events.length && clientId) {
    apiRequest(
      GTM_FALLBACK_API.method,
      GTM_FALLBACK_API.endpoint,
      {
        google_client_id: clientId,
        events,
      },
    );
  }
};

export function initializeFallback() {
  setInterval(() => {
    sendEventsToServer();
  }, 12000);

  window.addEventListener('unload', () => {
    sendEventsToServer();
  });
}
